/**
 * Emoji-Filterung (Ticket #1019) – spiegelt die Backend-Logik
 * (EmojiFilterable im Rails-Backend).
 *
 * Erfasst: Piktogramme (inkl. ★, ✅ …), Skin-Tone-Modifier, Länderflaggen
 * (Regional-Indicator-Paare), Variation-Selector-16 (FE0F), Zero-Width-Joiner
 * (200D) und Combining-Enclosing-Keycap (20E3).
 * Bleibt erhalten: Ziffern, Umlaute, €, E-Mails, Zeilenumbrüche.
 *
 * Bewusst framework-frei gehalten, damit es überall wiederverwendbar ist
 * (Direktive, Validator, Services …) und schnell an weiteren Stellen
 * "eingetütet" werden kann.
 */
const EMOJI_SOURCE =
  '[\\p{Extended_Pictographic}\\p{Emoji_Modifier}\\u{1F1E6}-\\u{1F1FF}\\uFE0F\\u200D\\u20E3]';

/**
 * Entfernt Emojis aus einem String. Nicht-Strings (null/undefined/Zahlen …)
 * werden unverändert zurückgegeben.
 *
 * Wichtig für die Live-Eingabe (onInput): Nur wenn tatsächlich ein Emoji
 * entfernt wurde, werden die dabei entstandenen doppelten/randständigen
 * Leerzeichen aufgeräumt (z. B. das oft mitkopierte Leerzeichen bei "😀 ").
 * Enthält der Wert kein Emoji, bleibt er komplett unverändert – sonst würde
 * beim Tippen das Leerzeichen am Wortende sofort wieder verschwinden und man
 * könnte keine Leertaste setzen. Das endgültige Trimmen normaler Eingaben
 * übernimmt ohnehin das Backend (EmojiFilterable).
 */
export function stripEmojis<T>(value: T): T {
  if (typeof value !== 'string') {
    return value;
  }

  const withoutEmojis = value.replace(new RegExp(EMOJI_SOURCE, 'gu'), '');
  if (withoutEmojis === value) {
    return value;
  }

  const cleaned = withoutEmojis.replace(/[ \t]{2,}/g, ' ').trim();
  return cleaned as unknown as T;
}

/**
 * Prüft, ob ein String mindestens ein Emoji enthält.
 */
export function containsEmoji(value: string | null | undefined): boolean {
  return typeof value === 'string' && new RegExp(EMOJI_SOURCE, 'u').test(value);
}
